





































import { Component, Prop, Vue } from "vue-property-decorator";
import { SurveyItem } from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class NumberItem extends Vue {
  //decimals→小数のみ
  //numberRuleDmical = { required: false, max: 10, decimal: true };
  //小数と整数両方可能
  numberRuleDmical = {
    required: false,
    max: 10,
    regex: /^([1-9]\d*|0)(\.\d+)?$/
  };
  numberRuleInteger = { required: false, max: 10, integer: true };
  numberRules = { required: false, max: 10 };
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({ type: String, default: "" })
  value!: string;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  localValue!: string;

  created() {
    if (this.item.unitsRules == true) {
      this.numberRules = {
        ...this.numberRuleDmical,
        ...this.item.rules
      };
    } else {
      this.numberRules = {
        ...this.numberRuleInteger,
        ...this.item.rules
      };
    }
    if (this.value == "") {
      this.localValue = localStorage.getItem(this.item.id) ?? "";
      this.$emit("input", this.localValue);
    } else {
      this.localValue = this.value;
    }
  }

  updateValue(value: string) {
    localStorage.setItem(this.item.id, value);
    this.localValue = value;
    this.$emit("input", value);
  }
}
